$(document).ready(function() {
    adaptVideoGallery()

    $('.js_video-gallery__item_vimeo').each((i,el) => {
        let src = $(el).find('iframe').attr('src')
        let newSrc = src.slice(0, src.indexOf('?')) + '?mute=0'
        $(el).attr('data-src', newSrc)
    })

    $('.js_video-gallery').each((i,el) => {
        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            autoHeight: true,
            breakpoints: {
                568: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            },
            navigation: {
                nextEl: '.js_video-gallery_next',
                prevEl: '.js_video-gallery_prev'
            },
            pagination: {
                el: '.js_video-gallery__pagi',
                bulletClass: 'global__pagi-item',
                bulletActiveClass: 'active'
            },
            modules: [SwiperModes.Navigation, SwiperModes.Pagination]
        })

        lightGallery(el, {
            selector: '.video-gallery__item',
            licenseKey: 'your_license_key',
            speed: 500,
            iframe: true,
            autoplay: true,
            vimeoPlayerParams: {
                autoplay: 1,
            },
            plugins: [lgModules.lgVideo, lgModules.lgAutoplay]
        })
    })
})

$(window).on('resize', function() {
    adaptVideoGallery()
})

function adaptVideoGallery() {
    $('.js_video-gallery__video').each((i,el) => {
        let big = $(el).attr('data-big')
        let small = $(el).attr('data-small')
        let src = $(el).attr('data-video')
        if ($(window).outerWidth() > 575) {
            $(el).attr('data-video', src.replace(small, big))
        } else {
            $(el).attr('data-video', src.replace(big, small))
        }
    })
}